class TaskMaster {
  constructor(data) {
    this.pk = data.pk;
    this.name = data.name;
    this.description = data.description;
    this.entryPointStatus = data.entry_point_status;
    this.entityContentTypeName = data.entity_content_type_name;
    this.defaultStatus = data.default_status;
    this.entityContentTypePk = data.entity_content_type_pk;
    this.businessAdminRoles = data.business_admin_roles;
    this.applicableStatuses = data.applicable_statuses;
    this.closureStatuses = data.closure_statuses;
    this.slaUnit = data.sla_unit;
    this.sla = data.sla;
    this.slaBreachTime = data.sla_breach_time;
    this.createEventQueues = data.create_event_queues;
    this.updateEventQueues = data.update_event_queues;
    this.extraData = data.extra_data;
    this.isActive = data.is_active ?? true;
  }
}
export default TaskMaster;